import styled from "styled-components/macro";

export const CompaniesWrapperStyles = styled.div`
  .header-wrapper {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  &.campaign-wrapper {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  .filter-bar-menus {
    display: flex;
    align-items: center;
    gap: 12px;
  }

  .go-back-wrapper {
    display: flex;
    align-items: center;

    .go-back-icon {
      border-radius: 50%;
      display: flex;
      align-items: center;
      cursor: pointer;

      &:hover {
        background-color: var(--Neutral-4);
      }

      svg {
        margin: 10px;
      }
    }

    .update-text-wrapper {
      display: flex;
      align-items: center;
      gap: 8px;
      padding: 4px;

      .truncate-text {
        color: var(--Neutral-100);
        font-size: 24px;
        font-weight: 600;
        line-height: 32px;
        letter-spacing: -0.048px;
      }

      .company-cell {
        display: flex;
        align-items: center;
        gap: 8px;

        .placeholder-logo {
          border-radius: 50%;
          background: var(--Brand-8);
          padding: 6px;
          display: flex;
          align-items: center;

          svg {
            width: 20px;
            height: 20px;
          }
        }

        img {
          border-radius: 50%;
          width: 32px;
          height: 32px;
        }
      }
    }
  }

  .talent-agency-table-wrapper {
    display: flex;
    flex-direction: column;
    gap: 8px;

    .filter-bars {
      display: flex;
      align-items: center;
      justify-content: space-between;
      gap: 12px;
    }
  }
`;
